export const REAL_NAME_SHOW = 'REAL_NAME_SHOW'; // 显示实名制弹窗
export const SHOW_1080P = 'SHOW_1080P'; // 显示1080P引导
export const RESET_SLIDER_STAT = 'RESET_SLIDER_STAT'; // 重置滑动组件状态
export const SLIDER_TO_INDEX = 'SLIDER_TO_INDEX'; // 滑动组件到INDEX
export const SLIDER_TO_END = 'SLIDER_TO_END'; // 滑动组件到最后
export const RESET_SLIDER_INDEX = 'RESET_SLIDER_INDEX'; // 重置滑动组件自动定位
export const SHOW_VIDEO_CARD = 'SHOW_VIDEO_CARD'; // 显示视频详情卡片
export const HIDE_VIDEO_CARD = 'HIDE_VIDEO_CARD'; // 隐藏视频详情卡片
export const TRIGGER_PAY_PROCESS = 'TRIGGER_PAY_PROCESS'; // 触发付费弹窗
export const TRIGGER_PAY_ENTRY = 'TRIGGER_PAY_ENTRY'; // 付费提醒
export const TRIGGER_TICKET_PROCESS = 'TRIGGER_TICKET_PROCESS'; // 触发用券观看弹窗
export const COIN_DIALOG = 'COIN_DIALOG'; // 投币弹窗
export const COIN_SUCCESS = 'COIN_SUCCESS'; // 投币成功
export const SIX_MIN_MASK_SHOW = 'SIX_MIN_MASK_SHOW'; // 6分钟预览播放结束遮罩
export const SHOW_SPONSOR_RANK = 'SHOW_SPONSOR_RANK'; // 显示承包榜
export const RANK_TAB_CHANGE = 'RANK_TAB_CHANGE'; // 承包榜Tab切换
export const TRIGGER_FOLLOW_ANIME = 'TRIGGER_FOLLOW_ANIME'; // 触发follow动画
export const FETCH_SPONSOR_RANK = 'FETCH_SPONSOR_RANK'; // 请求承包榜接口
export const SPONSOR_PAY_SUCCESS = 'SPONSOR_PAY_SUCCESS'; // 承包成功回调
export const TRIGGER_SPONSOR_PAY = 'TRIGGER_SPONSOR_PAY'; // 调用承包支付
export const TRIGGER_SPONSOR_RANK = 'TRIGGER_SPONSOR_RANK'; // 调用承包支付
export const RELOAD_PLAYER_SOURCE = 'RELOAD_PLAYER_SOURCE'; // 重置播放器
export const TRIGGER_REVIEW_OPEN = 'TRIGGER_REVIEW_OPEN'; // 触发开通点评弹窗
export const TRIGGER_SHORT_REVIEW = 'TRIGGER_SHORT_REVIEW'; // 触发发表/更新短评弹窗
export const SHORT_REVIEW_SUCCESS = 'SHORT_REVIEW_SUCCESS'; // 短评发表/更新成功回调
export const REVIEW_OPEN_SUCCESS = 'REVIEW_OPEN_SUCCESS'; // 开通点评成功回调
export const TRIGGER_REPORT_DIALOG = 'TRIGGER_REPORT_DIALOG'; // 触发举报弹窗
export const TRIGGER_UPGRADE_REVIEW = 'TRIGGER_UPGRADE_REVIEW'; // 触发长评升级提示
export const CLICK_DEMAND = 'CLICK_DEMAND'; // 超前点播单集
export const CLICK_DEMAND_PACK = 'CLICK_DEMAND_PACK'; // 超前点播多集付费